import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import FlowSection from "./routes/FlowSection";
import { AssessmentDetails } from "Assessments";
import { LeDetails } from "LearningEngagement";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
import { showNewUnitFlow } from "UnitPlanDetails/routes/IBPlanner/modules/Utils";

export default store => ({
  path: "unitFlow",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "unit-planner" */ "./components"),
        import(
          /* webpackChunkName: "unit-planner" */ "./modules/UnitFlowModule"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "OrganizationResources/modules/OrganizationResourcesModule"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "../UnitFlowV3/components"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "../UnitFlowV3/modules/UnitFlowModule"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "AppComponents/EntityFlowComponents/ImportFromUnitFlowModal/modules/Module"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
        ]) => {
          const _isUnitFlowRevampEnabled = showNewUnitFlow();

          const component = _isUnitFlowRevampEnabled
            ? importedModule3.default
            : importedModule0.default;
          const reducer = _isUnitFlowRevampEnabled
            ? importedModule4.default
            : importedModule1.default;
          const OrganizationResourcesReducer = importedModule2.default;
          injectReducer(store, {
            key: "organizationResource",
            reducer: OrganizationResourcesReducer,
          });
          injectReducer(store, {
            key: "unitFlow",
            reducer,
          });
          const importFromUnitFlowModalReducer = importedModule5.default;
          injectReducer(store, {
            key: "importFromUnitFlow",
            reducer: importFromUnitFlowModalReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    LeDetails(store),
    AssessmentDetails(store),
    FlowSection(store),
    ClassRoomDetails(store),
  ],
});
